export const CONTRIBUTORS_VERSION_3 = [
  {
    key: '1',
    name: 'Luis Calle',
    role: ['Project Manager']
  },
  {
    key: '2',
    name: 'Carolina Barco',
    role: ['Business Analyst']
  },
  {
    key: '3',
    name: 'Danny Goncalves',
    role: ['Developer']
  },
  {
    key: '4',
    name: 'Andrés Felipe Mejía',
    role: ['Developer']
  },
  {
    key: '5',
    name: 'Juan Valencia',
    role: ['Developer']
  },
  {
    key: '6',
    name: 'David Hernández',
    role: ['Developer']
  },
  {
    key: '7',
    name: 'Kharis Alvarado',
    role: ['Developer']
  },
  {
    key: '8',
    name: 'William Prado',
    role: ['Developer']
  },
  {
    key: '9',
    name: 'Alejandra Sánchez',
    role: ['Tester']
  },
  {
    key: '10',
    name: 'Diver Muñoz',
    role: ['Tester']
  },
  {
    key: '11',
    name: 'Freddy Viracacha',
    role: ['Tester']
  },
  {
    key: '12',
    name: 'Juan Chaverra',
    role: ['Tester']
  },
  {
    key: '13',
    name: 'Diego Arias',
    role: ['Devops']
  },
  {
    key: '14',
    name: 'Edwin Ultengo',
    role: ['Devops']
  },
  {
    key: '15',
    name: 'Eric Herrera',
    role: ['Devops']
  }
]
export const CONTRIBUTORS_VERSION_2_1 = [
  {
    key: '1',
    name: 'Luis Calle',
    role: ['Project Manager']
  },
  {
    key: '2',
    name: 'Carolina Barco',
    role: ['Business Analyst']
  },
  {
    key: '3',
    name: 'Danny Goncalves',
    role: ['Developer']
  },
  {
    key: '4',
    name: 'Andrés Felipe Mejía',
    role: ['Developer']
  },
  {
    key: '5',
    name: 'Juan Valencia',
    role: ['Developer']
  },
  {
    key: '6',
    name: 'David Hernández',
    role: ['Developer']
  },
  {
    key: '7',
    name: 'Kharis Alvarado',
    role: ['Developer']
  },
  {
    key: '8',
    name: 'William Prado',
    role: ['Developer']
  },
  {
    key: '9',
    name: 'Alejandra Sánchez',
    role: ['Tester']
  },
  {
    key: '10',
    name: 'Diver Muñoz',
    role: ['Tester']
  },
  {
    key: '11',
    name: 'Freddy Viracacha',
    role: ['Tester']
  },
  {
    key: '12',
    name: 'Juan Chaverra',
    role: ['Tester']
  },
  {
    key: '13',
    name: 'Jhonny Ocampo',
    role: ['Tester']
  },
  {
    key: '14',
    name: 'Diego Arias',
    role: ['Devops']
  },
  {
    key: '15',
    name: 'Edwin Ultengo',
    role: ['Devops']
  },
  {
    key: '16',
    name: 'Eric Herrera',
    role: ['Devops']
  },
  {
    key: '17',
    name: 'Sebastián Aya',
    role: ['Devops']
  }
]
export const CONTRIBUTORS_VERSION_2 = [
  {
    key: '1',
    name: 'Ana Sofia Arango',
    role: ['Tester']
  },
  {
    key: '2',
    name: 'Andres Mauricio Álvarez',
    role: ['Developer']
  },
  {
    key: '3',
    name: 'Andrés Felipe Mejía',
    role: ['Developer']
  },
  {
    key: '4',
    name: 'Beatriz Melo',
    role: ['Project Manager']
  },
  {
    key: '5',
    name: 'Carolina Barco',
    role: ['Business Analyst']
  },
  {
    key: '6',
    name: 'Danny Goncalves',
    role: ['Developer']
  },
  {
    key: '7',
    name: 'Edwin Ultengo',
    role: ['Devops']
  },
  {
    key: '8',
    name: 'Eloy Díaz',
    role: ['Developer']
  },
  {
    key: '9',
    name: 'Ferney Estupiñán',
    role: ['Developer']
  },
  {
    key: '10',
    name: 'Francisco Villarreal',
    role: ['Developer']
  },
  {
    key: '11',
    name: 'Hector Daniel Villarreal',
    role: ['Developer']
  },
  {
    key: '12',
    name: 'Jaime Martinez',
    role: ['Developer']
  },
  {
    key: '13',
    name: 'Josimar Sanchez',
    role: ['Developer']
  },
  {
    key: '14',
    name: 'José Tobón',
    role: ['Tester']
  },
  {
    key: '15',
    name: 'Juan Gomez',
    role: ['Developer']
  },
  {
    key: '16',
    name: 'Juan Valencia',
    role: ['Developer']
  },
  {
    key: '17',
    name: 'Luis Gabriel Rodriguez',
    role: ['Developer']
  },
  {
    key: '18',
    name: 'Mateo Tapias',
    role: ['Devops']
  },
  {
    key: '19',
    name: 'Max Carmona',
    role: ['Developer']
  },
  {
    key: '20',
    name: 'Nathalie Rivas',
    role: ['Developer']
  },
  {
    key: '21',
    name: 'Sebastian Rebolledo',
    role: ['Devops']
  }
]
export const CONTRIBUTORS_VERSION_1 = [
  {
    key: '1',
    name: 'Beatriz Melo',
    role: ['Project Manager']
  },
  {
    key: '2',
    name: 'Carlos Eduardo Berroteran',
    role: ['Developer']
  },
  {
    key: '3',
    name: 'Daniel Arafat Torres',
    role: ['Developer']
  },
  {
    key: '4',
    name: 'David Alejandro Sánchez',
    role: ['Devops']
  },
  {
    key: '5',
    name: 'David Córdoba',
    role: ['Business Analyst']
  },
  {
    key: '6',
    name: 'David Mogollón',
    role: ['Developer']
  },
  {
    key: '7',
    name: 'Deivis Ojeda',
    role: ['Tester']
  },
  {
    key: '8',
    name: 'Diego Garavito',
    role: ['Tester']
  },
  {
    key: '9',
    name: 'Ferney Estupiñan',
    role: ['Developer']
  },
  {
    key: '10',
    name: 'Jaime Martínez',
    role: ['Developer']
  },
  {
    key: '11',
    name: 'Jham Pier Alzate',
    role: ['Tester']
  },
  {
    key: '12',
    name: 'Jhonny Montano',
    role: ['Project Manager']
  },
  {
    key: '13',
    name: 'José Tobón',
    role: ['Tester']
  },
  {
    key: '14',
    name: 'Josimar Sánchez',
    role: ['Developer']
  },
  {
    key: '15',
    name: 'Juan Camilo Gómez',
    role: ['Developer']
  },
  {
    key: '16',
    name: 'Juan David Murillo',
    role: ['Tester']
  },
  {
    key: '17',
    name: 'Juan Fernando Rojas',
    role: ['Developer']
  },
  {
    key: '18',
    name: 'Juan Gallego Pineda',
    role: ['Devops']
  },
  {
    key: '19',
    name: 'Juan Manuel Chaverra',
    role: ['Tester']
  },
  {
    key: '20',
    name: 'Laura Vergara',
    role: ['Tester']
  },
  {
    key: '21',
    name: 'Mario Briceño',
    role: ['Project Manager']
  },
  {
    key: '22',
    name: 'Nathalie Rivas',
    role: ['Developer']
  },
  {
    key: '23',
    name: 'Santiago Agudelo',
    role: ['Developer']
  },
  {
    key: '24',
    name: 'Sebastian Rebolledo',
    role: ['Devops']
  },
  {
    key: '25',
    name: 'Vanesa Mazzaro',
    role: ['UX/UI']
  }
]
export const CONTRIBUTORS_VERSION_0 = [
  {
    key: '1',
    name: 'Andrés Felipe Mejía',
    role: ['Developer']
  },
  {
    key: '2',
    name: 'Beatriz Melo',
    role: ['Project Manager']
  },
  {
    key: '3',
    name: 'David Alcaráz',
    role: ['Developer']
  },
  {
    key: '4',
    name: 'Diana Rodríguez',
    role: ['Developer']
  },
  {
    key: '5',
    name: 'Jairo Enrique Díaz',
    role: ['Business Analyst']
  },
  {
    key: '6',
    name: 'Juan David Murillo',
    role: ['Tester']
  },
  {
    key: '7',
    name: 'Mateo Tapias',
    role: ['Devops']
  },
  {
    key: '8',
    name: 'Steven Goez',
    role: ['Developer']
  }
]
